/* src/app/modules/subscription/ocr-purchase-dialog/ocr-purchase-dialog.component.css */
.ocr-dialog {
  padding: 22px 24px 18px;
  text-align: center;
}
.ocr-title {
  margin: 0 0 12px;
  font-size: 1.3rem;
  font-weight: 700;
  color: #0f172a;
}
.ocr-line {
  margin: 0;
  color: #334155;
  font-size: 0.95rem;
}
.ocr-price {
  margin: 8px 0 0;
  color: #0f172a;
  font-size: 1.05rem;
  font-weight: 700;
}
.ocr-note {
  margin: 12px 0 0;
  color: #64748b;
  font-size: 0.9rem;
}
.ocr-actions {
  margin-top: 18px;
  display: flex;
  justify-content: center;
  gap: 10px;
}
.btn-cancel,
.btn-ok {
  border-radius: 8px;
  padding: 9px 18px;
  font-weight: 700;
  cursor: pointer;
}
.btn-cancel {
  border: 1px solid #cbd5e1;
  background: #ffffff;
  color: #334155;
}
.btn-ok {
  border: 1px solid var(--cf-brand-dark);
  background: var(--cf-brand-dark);
  color: #ffffff;
}
/*# sourceMappingURL=ocr-purchase-dialog.component.css.map */
